import { __awaiter, __generator } from "tslib";
import { HeatmapKey } from './';
var rgb2hex = function (red, green, blue) {
    // tslint:disable-next-line:no-bitwise
    var rgb = blue | (green << 8) | (red << 16);
    return '#' + (0x1000000 + rgb).toString(16).slice(1);
};
export var createHeatmapDriver = function (wrapper) {
    var base = wrapper.$("." + HeatmapKey);
    return {
        getCellColor: function (col, row) { return __awaiter(void 0, void 0, void 0, function () {
            var colomn, cell, style, matched, rgb;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        colomn = base.$$('.col-container').get(col);
                        cell = colomn.$$('.mat-item').get(row);
                        return [4 /*yield*/, cell.attr('style')];
                    case 1:
                        style = _a.sent();
                        if (style) {
                            matched = style.match(/background-color: rgb\((.*?)\)/);
                            if (matched && matched.length > 1) {
                                rgb = matched[1].split(', ').map(function (m) { return Number(m); });
                                if (rgb.length === 3) {
                                    return [2 /*return*/, rgb2hex(rgb[0], rgb[1], rgb[2])];
                                }
                            }
                        }
                        return [2 /*return*/, ''];
                }
            });
        }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map